export const ELIGIBLE_FOR_RETURN_PERIOD = 17; // days
export const ORDER_RETURN_REQUEST_FAST_TRACK_PERIOD = 14;
export const ORDER_RETURN_EXCLUDED_STATUSES = [
  'error',
  'fraud',
  'holded_order_cancelled',
  'paypal_canceled_reversal',
  'paypal_reversed',
  'pending_payment',
  'pending_paypal',
  'received',
  'rejected',
  'pending',
];
